<template>
  <b-row>
    <b-col cols="12">
      <b-card-actions ref="list"
title="" action-refresh @refresh="refresh">

        <div class="m-2">

          <!-- Table Top -->
          <b-row>

            <!-- Per Page -->
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <export-excel
                :data="roles"
                :columns="excel_columns"
                :file-name="'document_sections'"
                :file-type="'xlsx'"
                :sheet-name="'sheetname'"
              >
                <feather-icon icon="DownloadIcon" />
              </export-excel>

              <b-button
                variant="primary"
                class="button-inline-spacing-2"

                @click="newRole()"
                :disabled="editDisabled"
              >
                <span class="text-nowrap">{{ $t("Add role") }}</span>
              </b-button>
            </b-col>

            <!-- Search -->
            <b-col
              cols="12"
              md="6"
            >

              <b-form-input
                v-model="searchTerm"
                :placeholder="$t('message.SearchPlaceholder')"
                type="text"
                class="d-inline-block"
              />
            </b-col>
          </b-row>

        </div>

        <!-- alert -->
        <!--b-alert
          variant="primary"
          show
        >
          <div class="alert-body">
          </div>
        </b-alert-->

        <!-- search input -->
        <div class="custom-search d-flex justify-content-end"/>

        <!-- table -->
        <vue-good-table
          :columns="columns"
          :rows="roles"
          :rtl="direction"
          :search-options="{
            enabled: true,
            externalQuery: searchTerm }"
          :select-options="{
            enabled: false,
            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true, // disable the select info panel on top
            selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
          }"
          :pagination-options="{
            enabled: true,
            perPage:pageLength
          }"
        >

          <!-- Slot: Table Column -->
          <template
            slot="table-column"
            slot-scope="props"
          >

            <span>
              {{ $t(props.column.label) }}
            </span>
          </template>

          <!-- Slot: Table Row -->
          <template
            slot="table-row"
            slot-scope="props"
          >

            <!-- Column: Name -->
            <span
              v-if="props.column.field === 'name'"
              class="text-nowrap v-align-middle"
            >
              <span>{{ props.row.name }}</span>
            </span>

            <!-- Column: Action -->
            <span v-else-if="props.column.field === 'action'"
class="button-inline-spacing">

              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon"
                @click="edit(props.row)"
>
                <feather-icon icon="Edit2Icon" />
              </b-button>

              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon"
                :disabled="editDisabled"
                @click="deleteRole(props.row)"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>

            </span>

            <span v-else
class="text-nowrap align-middle"/>
          </template>

          <!-- pagination -->
          <template
            slot="pagination-bottom"
            slot-scope="props"
          >

            <div class="d-flex justify-content-between flex-wrap">

              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap">
                  {{ $t('message.pagelength') }}
                </span>
                <b-form-select
                  v-model="pageLength"
                  :options="['3','5','10','15']"
                  class="mx-1"
                  @input="(value)=>props.perPageChanged({currentPerPage:value})"
                />
                <span class="text-nowrap">  {{ $t('message.of') }} {{ props.total }} {{
                  $t('message.pageText2')
                }} </span>

              </div>
              <div>

                <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value)=>props.pageChanged({currentPage:value})"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>

                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>

      </b-card-actions>

      <b-modal
        id="modal-role"
        cancel-variant="outline-secondary"
        :ok-title="$t('Save')"
        ok-s
        :cancel-title="$t('Cancel')"
        centered
        :title="$t('New role')"
        @ok="createRole"
      >
        <b-form>
          <b-form-group>
            <label for="new_role_name">{{ $t('New role') }}:</label>
            <b-form-input
              id="new_role"
              type="text"
              v-model="new_role_name"
              :placeholder="$t('Name')"
            />
          </b-form-group>
          <b-form-group>

            <label for="risks">{{ $t('Risks') }}:</label>
            <b-form-checkbox-group
              v-model="selected_risks"
              :options="checked_risks"
              class="mt-1 mx-auto"
              :stacked="true"

            />

          </b-form-group>

          <b-form-group>

            <label for="ppes">{{ $t('Personal Protection Equipments') }}:</label>
            <b-form-checkbox-group
              v-model="selected_ppes"
              :options="checked_ppes"
              class="mt-1 mx-auto"
              :stacked="true"
            />

          </b-form-group>

        </b-form>
      </b-modal>
      <b-modal
        id="modal-update-role"
        cancel-variant="outline-secondary"
        :ok-title="$t('Save')"
        ok-s
        :cancel-title="$t('Cancel')"
        centered
        :title="$t('Edit role')"
        @ok="updateRole"
      >
        <b-form>
          <b-form-group>
            <label for="new_role_name">{{ $t('New role name') }}:</label>
            <b-form-input
              id="new_role"
              type="text"
              v-model="new_role_name"
              :placeholder="$t('Name')"
            />
          </b-form-group>

          <b-form-group>

            <label for="risks">{{ $t('Risks') }}:</label>
            <b-form-checkbox-group
              v-model="selected_risks"
              :options="checked_risks"
              class="mt-1"
              :stacked="true"
            />

          </b-form-group>

          <b-form-group>

            <label for="ppes">{{ $t('Personal Protection Equipments') }}:</label>
            <b-form-checkbox-group
              v-model="selected_ppes"
              :options="checked_ppes"
              class="mt-1"
              :stacked="true"
            />

          </b-form-group>

        </b-form>
      </b-modal>
    </b-col>
  </b-row>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import { BCardActions } from '@core/components/b-card-actions';
import {
  BAvatar,
  BBadge,
  BPagination,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BAlert,
  BDropdown,
  BDropdownItem,
  BRow,
  BCol,
BButton} from 'bootstrap-vue'
import {VueGoodTable} from 'vue-good-table'
import store from '@/store/index'
import {codeI18n} from './code'
import useJwt from '@/auth/jwt/useJwt'
import UserService from "@/basic/userService";
import EquipmentService from "@/basic/equipmentService";
import Ripple from 'vue-ripple-directive'

import ExportExcel from '@/views/components/excel-export/ExportExcel';

import Vue from 'vue';
import i18n from '@/libs/i18n';
import ToastificationContent from '@core/components/toastification/ToastificationContent';
import ability from '@/libs/acl/ability';
import EmployeeService from '@/basic/employeeService';
import { BFormCheckboxGroup } from 'bootstrap-vue/src/components/form-checkbox';

Vue.use(ExportExcel)

export default {
  components: {
    BCardCode,
    BCardActions,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BAlert,
    BDropdown,
    BDropdownItem,
    BButton,
    BRow,
    BCol,
    BFormCheckbox,
    BFormCheckboxGroup,
    BForm,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      pageLength: 15,
      currentPerPage: 15,
      codeI18n,
      dir: false,
      editDisabled: !ability.can('manage', 'Basic HR'),
      columns: [
        {
          label: 'Name',
          field: 'name',
        },
        {
          label: 'Action',
          field: 'action',
        },

      ],
      excel_columns: [
        {
          label: i18n.t('Name'),
          field: 'name',
        },

      ],
      roles: [],
      risks: [],
      ppes: [],
      checked_risks: [],
      selected_risks: [],
      checked_ppes: [],
      selected_ppes: [],
      searchTerm: '',
      new_role: { name: '', risks: [], ppes: [] },
      new_role_name: '',
      edit_role_id: 0,

    }
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: 'light-primary',
        Professional: 'light-success',
        Rejected: 'light-danger',
        Resigned: 'light-warning',
        Applied: 'light-info',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  mounted() {
    console.log('mounted')
    this.$refs["list"].showLoading = true

    this.refresh()

    //this.$http.get('/good-table/basic')
    //.then(res => { this.roles = res.data })
  },
  methods: {
    initializeRisksCheckboxes(role) {
      this.checked_risks = []
      this.selected_risks = []
      this.risks.forEach(risk => {
        if (role.risks.find(r => r.id === risk.id))
          this.selected_risks.push(risk.id)
        this.checked_risks.push({'text': risk.name, 'value': risk.id})
      })
      console.log("checked_risks", this.checked_risks)
      console.log("selected_risks", this.selected_risks)
    },

    initializePPECheckboxes(role) {
      this.checked_ppes = []
      this.selected_ppes = []
      this.ppes.forEach(ppe => {
        if (role.personal_protective_equipments.find(r => r.id === ppe.id))
          this.selected_ppes.push(ppe.id)
        this.checked_ppes.push({'text': ppe.name, 'value': ppe.id})
      })
      console.log("checked_ppes", this.checked_ppes)
      console.log("selected_ppes", this.selected_ppes)
    },


    refresh() {
      console.log("refresh")
      this.$refs["list"].showLoading = true


      const employeeService = new EmployeeService(useJwt)

      employeeService.role_templates({}).then(response => {
        this.roles = response.data.data.roles
        this.risks = response.data.data.risks
        this.ppes = response.data.data.ppes
        console.log('roles', this.roles)
        this.$refs["list"].showLoading = false

      })

    },


    createRole() {
      console.log('new role name', this.new_role_name)
      const employeeService = new EmployeeService(useJwt)
      this.$refs["list"].showLoading = true
      this.new_role = {name: this.new_role_name};

      const data = {
        role: {name: this.new_role_name, selected_risks: this.selected_risks, selected_ppes: this.selected_ppes}

      };

      employeeService.update_role_template('new', data).then(response => {
        console.log("response", response)
        this.roles = response.data.data.roles;
        this.risks = response.data.data.risks
        this.ppes = response.data.data.ppes

        //this.role_new_id = response.data.data.role.id;
        //this.refresh();
        this.$refs["list"].showLoading = false
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: i18n.t('Role'),
            icon: 'AlertIcon',
            variant: 'success',
            text: i18n.t('Role saved with success'),
          },
        })
      })
      this.new_role_name = ""
      this.new_role = {name: this.new_role_name};

    },
    edit(row) {
      this.edit_role_id = row.id
      this.new_role_name = row.name
      this.new_role = row
      this.initializeRisksCheckboxes(row)
      this.initializePPECheckboxes(row)
      this.$bvModal.show('modal-update-role')
    },
    newRole() {
      this.edit_role_id = 0
      this.new_role_name = ''
      this.new_role = {name: this.new_role_name, risks: [], personal_protective_equipments: [], id: 0};
      this.initializeRisksCheckboxes(this.new_role)
      this.initializePPECheckboxes(this.new_role)

      this.$bvModal.show('modal-role')
    },
    updateRole() {

      const employeeService = new EmployeeService(useJwt)
      this.$refs["list"].showLoading = true

      const data = {
        role: {name: this.new_role_name, selected_risks: this.selected_risks, selected_ppes: this.selected_ppes}
      };

      employeeService.update_role_template(this.new_role.id, data).then(response => {
        console.log("response", response)
        this.refresh();

        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: i18n.t('Role'),
            icon: 'AlertIcon',
            variant: 'success',
            text: i18n.t('Role saved with success'),
          },
        })
      })
      this.new_role_name = ""

    },
    deleteRole(row) {
      console.log('delete')
      let confirmed = false;
      let message = i18n.t('You are deleting the role') + ": \"" + row.name + "\". " + i18n.t("Are you sure?");

      this.$bvModal
          .msgBoxConfirm(message, {
            title: i18n.t('Confirmation Required'),
            size: 'sm',
            okVariant: 'primary',
            okTitle: i18n.t('Proceed'),
            cancelTitle: i18n.t('Cancel'),
            cancelVariant: 'outline-secondary',
            hideHeaderClose: false,
            centered: true,
          })
          .then(value => {
            confirmed = value

            if (confirmed) {
              const employeeService = new EmployeeService(useJwt)
              employeeService.delete_role_template(row.id).then(response => {
                console.log('deletion response', response)

                if (response.data.status === 'success') {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: i18n.t('Role deleted'),
                      icon: 'AlertIcon',
                      variant: 'success',
                      text: i18n.t('Role deleted with success'),
                    },
                  })
                } else {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: i18n.t('Role not deleted'),
                      icon: 'AlertIcon',
                      variant: 'danger',
                      text: i18n.t(response.data.message),
                    },
                  })
                }

                this.refresh();
              })
            }
          })

    },


  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
